/* ========================================
   vc.js – VapeChamp Custom JavaScript
   Horizon v3.0 – Upgrade-Safe
   ======================================== */

/* ========================================
   1. CART TOOLTIP SYSTEM
   ======================================== */

const CartTooltip = (() => {
  let previousCartCount = 0;
  let hideTooltipTimeout = null;

  function ensureTooltipOnTop() {
    const cartTooltipWrapper = document.getElementById('vc-cart-tooltip-wrapper');
    if (!cartTooltipWrapper) return;

    // Check if modal is open - if so, move tooltip INTO modal
    const openModal = document.querySelector('dialog.dialog-modal[open]');

    if (openModal) {
      // Move into modal so it's in the Top Layer
      if (cartTooltipWrapper.parentElement !== openModal) {
        openModal.appendChild(cartTooltipWrapper);
      }
    } else {
      // No modal, keep in body
      if (cartTooltipWrapper.parentElement !== document.body) {
        document.body.appendChild(cartTooltipWrapper);
      }
    }
  }

  function positionTooltip() {
    const cartIconButton = document.querySelector('.header-actions__action[aria-label*="Warenkorb"], .header-actions__action[on\\:click*="cart"]');
    const cartTooltipWrapper = document.getElementById('vc-cart-tooltip-wrapper');

    if (!cartIconButton || !cartTooltipWrapper) return;

    // Get cart icon position
    const iconRect = cartIconButton.getBoundingClientRect();

    // Calculate position: below icon, aligned to icon center
    let top = iconRect.bottom + 10;
    const iconCenterX = iconRect.left + (iconRect.width / 2);

    // Pointer is 21px from right edge of tooltip (14px + 7px)
    let right = window.innerWidth - iconCenterX - 21;

    // If tooltip is inside a modal, compensate for modal's position and use absolute positioning
    const openModal = document.querySelector('dialog.dialog-modal[open]');
    const isInModal = openModal && cartTooltipWrapper.parentElement === openModal;

    if (isInModal) {
      const modalRect = openModal.getBoundingClientRect();
      // Compensate for modal's top offset
      top = top - modalRect.top;
      // Compensate for modal's left offset (convert viewport right to modal right)
      right = (window.innerWidth - modalRect.left) - iconCenterX - 21;
      cartTooltipWrapper.style.position = 'absolute';
    } else {
      cartTooltipWrapper.style.position = 'fixed';
    }

    // Set position directly on wrapper
    cartTooltipWrapper.style.top = top + 'px';
    cartTooltipWrapper.style.right = right + 'px';
    cartTooltipWrapper.style.left = 'auto';
    cartTooltipWrapper.style.bottom = 'auto';
    cartTooltipWrapper.style.margin = '0';
  }

  function showTooltip() {
    let cartTooltipWrapper = document.getElementById('vc-cart-tooltip-wrapper');
    if (!cartTooltipWrapper) return;

    // Clear any existing timeout
    if (hideTooltipTimeout) {
      clearTimeout(hideTooltipTimeout);
      hideTooltipTimeout = null;
    }

    // Hide if already visible
    cartTooltipWrapper.classList.remove('vc-tooltip-visible');

    setTimeout(() => {
      // Move tooltip into modal if one is open (to be in Top Layer)
      ensureTooltipOnTop();

      // IMPORTANT: Re-fetch element after ensureTooltipOnTop() because Shopify might have replaced it
      cartTooltipWrapper = document.getElementById('vc-cart-tooltip-wrapper');
      if (!cartTooltipWrapper) return;

      // Show and position
      cartTooltipWrapper.classList.add('vc-tooltip-visible');
      positionTooltip();

      // Set new timeout and store the ID
      hideTooltipTimeout = setTimeout(() => {
        // Hide ALL tooltip elements (in case Shopify created duplicates during re-renders)
        let hiddenCount = 0;
        let attempt = 0;
        const maxAttempts = 10; // Reduced from 50 to 10 (500ms max instead of 2.5s)

        // Keep trying to hide tooltips until none are visible
        const hideInterval = setInterval(() => {
          attempt++;

          // Find ALL elements with this ID (even though ID should be unique)
          const allTooltips = document.querySelectorAll('#vc-cart-tooltip-wrapper, .vc-cart-tooltip-wrapper');
          let foundVisible = false;

          allTooltips.forEach((wrapper) => {
            if (wrapper.offsetHeight > 0 || wrapper.classList.contains('vc-tooltip-visible') || wrapper.style.display === 'block') {
              wrapper.classList.remove('vc-tooltip-visible');
              wrapper.style.display = 'none';
              hiddenCount++;
              foundVisible = true;
            }
          });

          // Stop if no more visible tooltips or max attempts reached
          if (!foundVisible || attempt >= maxAttempts) {
            clearInterval(hideInterval);
            hideTooltipTimeout = null;
          }
        }, 50); // Check every 50ms
      }, 2500);
    }, 10);
  }

  function animateCartBubble() {
    const cartBubble = document.querySelector('.cart-bubble');
    if (!cartBubble) return;

    cartBubble.classList.remove('vc-cart-blink');
    void cartBubble.offsetWidth;
    cartBubble.classList.add('vc-cart-blink');

    setTimeout(() => {
      cartBubble.classList.remove('vc-cart-blink');
    }, 2000);
  }

  function handleCartCountChange(currentCartCount) {
    animateCartBubble();

    if (previousCartCount === 0 && currentCartCount > 0) {
      showTooltip();
    }

    previousCartCount = currentCartCount;
  }

  function initObserver() {
    const cartBubbleCount = document.querySelector('.cart-bubble__text-count');

    if (!cartBubbleCount) {
      setTimeout(initObserver, 100);
      return;
    }

    previousCartCount = parseInt(cartBubbleCount.textContent, 10) || 0;

    const observer = new MutationObserver(() => {
      const currentCartCount = parseInt(cartBubbleCount.textContent, 10) || 0;
      handleCartCountChange(currentCartCount);
    });

    observer.observe(cartBubbleCount, {
      characterData: true,
      childList: true,
      subtree: true
    });

    // Reposition tooltip on window resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const cartTooltipWrapper = document.getElementById('vc-cart-tooltip-wrapper');
        if (cartTooltipWrapper && cartTooltipWrapper.style.display === 'block') {
          positionTooltip();
        }
      }, 100);
    });
  }

  return {
    init: initObserver
  };
})();


/* ========================================
   2. MODAL CUSTOMIZATION SYSTEM
   ======================================== */

const ModalCustomization = (() => {
  function createCloseButton() {
    const closeButton = document.createElement('button');
    closeButton.className = 'vc-modal-close-button';
    closeButton.innerHTML = `
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 10l5 5 5-5z"/>
      </svg>
      <span>Schließen</span>
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 10l5 5 5-5z"/>
      </svg>
    `;
    return closeButton;
  }

  function addCloseButton(modal) {
    if (modal.querySelector('.vc-modal-close-button')) return;

    const closeButton = createCloseButton();
    closeButton.addEventListener('click', () => {
      const originalCloseButton = modal.querySelector('.quick-add-modal__close');
      if (originalCloseButton) {
        originalCloseButton.click();
      }
    });

    modal.appendChild(closeButton);
  }

  function addProductInfoIcon(modal) {
    const productTitleLink = modal.querySelector('.view-product-title a, .product-header a');
    if (!productTitleLink || productTitleLink.parentNode.querySelector('.vc-product-info-wrapper')) return;

    const productUrl = productTitleLink.getAttribute('href');
    if (!productUrl) return;

    const parentContainer = productTitleLink.parentNode;

    const iconWrapper = document.createElement('div');
    iconWrapper.className = 'vc-product-info-wrapper';

    const infoIcon = document.createElement('a');
    infoIcon.className = 'vc-product-info-icon';
    infoIcon.href = productUrl;
    infoIcon.innerHTML = `
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" stroke-width="1.5"/>
        <path d="M12 17V11" stroke-width="1.5" stroke-linecap="round"/>
        <circle cx="1" cy="1" r="1" transform="matrix(1 0 0 -1 11 9)"/>
      </svg>
    `;
    iconWrapper.appendChild(infoIcon);

    const titleWrapper = document.createElement('div');
    titleWrapper.className = 'vc-product-title-wrapper';
    titleWrapper.appendChild(productTitleLink);

    parentContainer.insertBefore(iconWrapper, parentContainer.firstChild);
    parentContainer.insertBefore(titleWrapper, parentContainer.firstChild);
  }

  function addFootnote(modal) {
    if (modal.querySelector('.vc-modal-footnote')) return;

    const footnote = document.createElement('div');
    footnote.className = 'vc-modal-footnote';
    footnote.innerHTML = `
      <p>* Alle Preise abhängig vom gewährten Mengenrabatt, zzgl. <a href="/pages/versandbedingungen">Versandkosten</a>, Versandkostenfrei ab 100,- € Warenwert.</p>
    `;

    // Try desktop: In .group-block-content einfügen
    const groupBlockContent = modal.querySelector('.quick-add-modal__content .group-block .group-block-content');
    if (groupBlockContent) {
      groupBlockContent.appendChild(footnote);
      return;
    }

    // Fallback: Direkt in modal content als letztes Element
    const modalContent = modal.querySelector('.quick-add-modal__content');
    if (modalContent) {
      modalContent.appendChild(footnote);
    }
  }

  function waitForModalContent(modal, callback, attempts = 0, maxAttempts = 40) {
    const priceElement = modal.querySelector('.quick-add-modal__content product-price');
    const productForm = modal.querySelector('product-form-component');
    const productDetails = modal.querySelector('.product-details');

    // For delivery status we only need priceElement and productForm
    // productDetails is optional (doesn't exist on mobile)
    if (priceElement && productForm) {
      callback();
      return;
    }

    if (attempts < maxAttempts) {
      setTimeout(() => waitForModalContent(modal, callback, attempts + 1, maxAttempts), 50);
    }
  }

  function customize() {
    const modal = document.querySelector('.quick-add-modal');
    if (!modal) return;

    addCloseButton(modal);

    setTimeout(() => {
      waitForModalContent(modal, () => {
        // Call product functions from window.VCProducts if available
        if (window.VCProducts) {
          window.VCProducts.DeliveryStatus.add(modal);
          window.VCProducts.PaymentButton.customize();
        }
        addFootnote(modal);
        addProductInfoIcon(modal);
      });
    }, 100);
  }

  function initObserver() {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1 && node.classList && node.classList.contains('quick-add-modal')) {
              if (node.hasAttribute('open')) {
                customize();
              }
            }
          });
        }

        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          const modal = mutation.target;
          if (modal.classList.contains('quick-add-modal') && modal.hasAttribute('open')) {
            customize();
          }
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['open']
    });
  }

  return {
    initObserver
  };
})();


/* ========================================
   3. COLLECTION PAGE ROW GRADIENTS
   ======================================== */

const CollectionRowGradients = (() => {
  function createGradients() {
    // Entferne alte Gradienten
    document.querySelectorAll('.vc-row-gradient').forEach(el => el.remove());

    const grid = document.querySelector('.product-grid');
    if (!grid) return;

    const items = Array.from(grid.querySelectorAll('.product-grid__item'));
    if (items.length === 0) return;

    const fullWidthContainer = document.body;
    fullWidthContainer.style.position = 'relative';

    // Gruppiere Items nach Zeilen (basierend auf offsetTop)
    const rows = [];
    let currentRow = [];
    let lastTop = null;

    items.forEach(item => {
      const top = item.offsetTop;

      if (lastTop === null || Math.abs(top - lastTop) < 5) {
        currentRow.push(item);
      } else {
        if (currentRow.length > 0) {
          rows.push(currentRow);
        }
        currentRow = [item];
      }
      lastTop = top;
    });

    if (currentRow.length > 0) {
      rows.push(currentRow);
    }

    // Erstelle Gradient für jede Zeile
    rows.forEach((rowItems) => {
      const firstItem = rowItems[0];
      const firstCardGallery = firstItem.querySelector('.card-gallery');

      if (!firstCardGallery) return;

      let maxImageHeight = 0;
      let maxTextHeight = 0;

      rowItems.forEach(item => {
        const cardGallery = item.querySelector('.card-gallery');

        if (cardGallery) {
          maxImageHeight = Math.max(maxImageHeight, cardGallery.offsetHeight);
        }

        const textBlock = item.querySelector('.text-block');
        const priceBlock = item.querySelector('product-price');

        if (textBlock && priceBlock) {
          const textHeight = textBlock.offsetHeight + priceBlock.offsetHeight;
          maxTextHeight = Math.max(maxTextHeight, textHeight);
        }
      });

      const galleryRect = firstCardGallery.getBoundingClientRect();
      const gradientTop = galleryRect.bottom + window.scrollY;

      const gradientDiv = document.createElement('div');
      gradientDiv.className = 'vc-row-gradient';
      gradientDiv.style.cssText = `
        position: absolute;
        left: 0;
        width: 100%;
        top: ${gradientTop}px;
        height: ${maxTextHeight + 30}px;
        background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(230, 230, 230, 1) 100%);
        backdrop-filter: blur(8px);
        -webkit-backdrop-filter: blur(8px);
        border-bottom: 1px solid rgba(210, 210, 210, 1);
        pointer-events: none;
        z-index: -1;
      `;

      fullWidthContainer.appendChild(gradientDiv);
    });

    items.forEach(item => {
      item.style.position = 'relative';
      item.style.zIndex = '1';
    });
  }

  function initObservers() {
    // Bei Window Resize
    window.addEventListener('resize', () => {
      requestAnimationFrame(createGradients);
    });

    // Bei Shopify Section Events
    document.addEventListener('shopify:section:load', createGradients);
    document.addEventListener('shopify:section:reorder', createGradients);

    // Bei dynamischen Inhalten (Pagination, Filter)
    const grid = document.querySelector('.product-grid');
    if (grid) {
      const observer = new MutationObserver(() => {
        createGradients();
      });

      observer.observe(grid, { childList: true, subtree: true });
    }
  }

  function init() {
    if (document.readyState !== 'loading') {
      createGradients();
    }

    document.addEventListener('DOMContentLoaded', () => {
      createGradients();
      initObservers();
    });

    window.addEventListener('load', createGradients, { once: true });
  }

  return {
    init
  };
})();


/* ========================================
   4. CART RECOMMENDATIONS SYSTEM
   ======================================== */

const CartRecommendations = (() => {
  let isUpdatingRecommendation = false;
  let lastRecommendedProductId = null; // Track last recommended product

  async function fetchRecommendations(productId, limit = 10) {
    try {
      const response = await fetch(`/recommendations/products.json?product_id=${productId}&limit=${limit}`);
      if (!response.ok) return null;
      const data = await response.json();
      return data.products || [];
    } catch (error) {
      console.error('Recommendations fetch error:', error);
      return null;
    }
  }

  function createRecommendationHTML(product, cartVariantIds = []) {
    // Get all available variants that are NOT in cart
    const availableVariants = product.variants?.filter(v => v.available && !cartVariantIds.includes(v.id));
    if (!availableVariants || availableVariants.length === 0) return ''; // No available variant found that's not in cart

    // Randomly select one variant from available variants
    const variant = availableVariants[Math.floor(Math.random() * availableVariants.length)];

    const price = variant.price / 100;
    const comparePrice = variant.compare_at_price ? variant.compare_at_price / 100 : null;
    const priceFormatted = `${price.toFixed(2).replace('.', ',')} €`;
    const comparePriceFormatted = comparePrice ? `${comparePrice.toFixed(2).replace('.', ',')} €` : null;

    const image = product.images?.[0] || product.featured_image;
    const imageUrl = image ? image.replace(/\.(jpg|png|webp)/, '_150x.$1') : '';

    const hasComparePrice = comparePrice && comparePrice > price;

    return `
      <div class="vc-cart-item vc-cart-item--recommendation" data-product-id="${product.id}" data-variant-id="${variant.id}" data-price="${price}">
        <div class="vc-cart-item__title-row vc-cart-item__title-row--recommendation">
          <a href="/products/${product.handle}" class="vc-cart-item__title">
            ${product.title}${variant.title !== 'Default Title' ? ` <span class="vc-cart-item__variant-name">- ${variant.title}</span>` : ''}
          </a>
          <span class="vc-cart-item__recommendation-badge">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="vc-cart-item__badge-icon">
              <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="currentColor"/>
            </svg>
            Empfehlung
          </span>
        </div>

        <div class="vc-cart-item__main-row">
          <div class="vc-cart-item__media-quantity">
            ${imageUrl ? `
              <a href="/products/${product.handle}" class="vc-cart-item__media">
                <img src="${imageUrl}" alt="${product.title}" class="vc-cart-item__image" loading="lazy">
              </a>
            ` : ''}

            <div class="vc-cart-item__controls">
              <quantity-selector-component class="quantity-selector vc-cart-quantity vc-cart-quantity--recommendation">
                <button class="button quantity-minus button-unstyled" type="button" name="minus" onclick="CartRecommendations.updateQuantity(this, -1)">
                  <span class="visually-hidden">Verringern</span>
                  <span class="svg-wrapper icon-minus">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2.75 7H11.25" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round"/>
                    </svg>
                  </span>
                </button>
                <input type="number" name="quantity" value="0" min="0" step="1"
                       oninput="CartRecommendations.updatePrice(this)">
                <button class="button quantity-plus button-unstyled" type="button" name="plus" onclick="CartRecommendations.updateQuantity(this, 1)">
                  <span class="visually-hidden">Erhöhen</span>
                  <span class="svg-wrapper icon-plus">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path class="vertical" d="M2.75 7H11.25" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round"/>
                      <path class="horizontal" d="M7 2.75L7 11.25" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round"/>
                    </svg>
                  </span>
                </button>
              </quantity-selector-component>
              <button class="vc-rec-add-to-cart hidden" type="button" onclick="CartRecommendations.addToCartFromButton(this)" aria-label="In den Warenkorb">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16.608 9.421V6.906H3.392v8.016c0 .567.224 1.112.624 1.513.4.402.941.627 1.506.627H8.63M8.818 3h2.333c.618 0 1.212.247 1.649.686a2.35 2.35 0 0 1 .683 1.658v1.562H6.486V5.344c0-.622.246-1.218.683-1.658A2.33 2.33 0 0 1 8.82 3"></path>
                  <path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M14.608 12.563v5m2.5-2.5h-5"></path>
                </svg>
              </button>
              <button class="vc-rec-reload" type="button" onclick="CartRecommendations.reloadRecommendations()" aria-label="Neue Empfehlungen laden">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path fill="currentColor" d="M480.1 192l7.9 0c13.3 0 24-10.7 24-24l0-144c0-9.7-5.8-18.5-14.8-22.2S477.9 .2 471 7L419.3 58.8C375 22.1 318 0 256 0 127 0 20.3 95.4 2.6 219.5 .1 237 12.2 253.2 29.7 255.7s33.7-9.7 36.2-27.1C79.2 135.5 159.3 64 256 64 300.4 64 341.2 79 373.7 104.3L327 151c-6.9 6.9-8.9 17.2-5.2 26.2S334.3 192 344 192l136.1 0zm29.4 100.5c2.5-17.5-9.7-33.7-27.1-36.2s-33.7 9.7-36.2 27.1c-13.3 93-93.4 164.5-190.1 164.5-44.4 0-85.2-15-117.7-40.3L185 361c6.9-6.9 8.9-17.2 5.2-26.2S177.7 320 168 320L24 320c-13.3 0-24 10.7-24 24L0 488c0 9.7 5.8 18.5 14.8 22.2S34.1 511.8 41 505l51.8-51.8C137 489.9 194 512 256 512 385 512 491.7 416.6 509.4 292.5z"/>
                </svg>
              </button>
            </div>
          </div>

          <div class="vc-cart-item__total-price vc-cart-item__total-price--recommendation">
            <div class="vc-rec-unit-price">
              <span class="vc-rec-price">${priceFormatted}</span>
              ${hasComparePrice ? `<span class="vc-rec-compare-price">${comparePriceFormatted}</span>` : ''}
            </div>
            <div class="vc-rec-total-price">0,00 €</div>
          </div>
        </div>
      </div>
    `;
  }

  function updateQuantity(button, delta) {
    const input = button.parentElement.querySelector('input[type="number"]');
    const currentValue = parseInt(input.value, 10) || 0;
    const newValue = Math.max(0, currentValue + delta);

    input.value = newValue;
    updatePrice(input);

    // Show/hide add to cart button and reload button based on quantity
    const controls = button.closest('.vc-cart-item__controls');
    const addToCartBtn = controls.querySelector('.vc-rec-add-to-cart');
    const reloadBtn = controls.querySelector('.vc-rec-reload');

    if (newValue >= 1) {
      if (addToCartBtn) addToCartBtn.classList.remove('hidden');
      if (reloadBtn) reloadBtn.classList.add('hidden');
    } else {
      if (addToCartBtn) addToCartBtn.classList.add('hidden');
      if (reloadBtn) reloadBtn.classList.remove('hidden');
    }
  }

  function updatePrice(input) {
    const recItem = input.closest('.vc-cart-item--recommendation');
    const price = parseFloat(recItem.getAttribute('data-price'));
    const quantity = parseInt(input.value, 10) || 0;
    const total = price * quantity;
    const totalFormatted = `${total.toFixed(2).replace('.', ',')} €`;

    const totalPriceDiv = recItem.querySelector('.vc-rec-total-price');
    if (totalPriceDiv) {
      totalPriceDiv.textContent = totalFormatted;
    }
  }

  function addToCartFromButton(button) {
    const recItem = button.closest('.vc-cart-item--recommendation');
    const variantId = recItem.getAttribute('data-variant-id');
    const input = recItem.querySelector('input[type="number"]');
    const quantity = parseInt(input.value, 10) || 0;

    if (quantity < 1) return;

    addToCart(variantId, quantity, button);
  }

  async function addToCart(variantId, quantity, triggerElement) {
    try {
      // Set flag to prevent reload during add
      isUpdatingRecommendation = true;

      const formData = {
        items: [{
          id: variantId,
          quantity: quantity
        }]
      };

      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        // Fetch updated cart HTML
        const cartResponse = await fetch(window.location.href);
        const cartHTML = await cartResponse.text();

        const parser = new DOMParser();
        const doc = parser.parseFromString(cartHTML, 'text/html');

        // Update cart items section
        const currentCartItems = document.querySelector('.cart-items');
        const newCartItems = doc.querySelector('.cart-items');
        if (currentCartItems && newCartItems) {
          currentCartItems.innerHTML = newCartItems.innerHTML;
        }

        // Update cart summary
        const currentSummary = document.querySelector('.cart-drawer__summary');
        const newSummary = doc.querySelector('.cart-drawer__summary');
        if (currentSummary && newSummary) {
          currentSummary.innerHTML = newSummary.innerHTML;
        }

        // Update all cart icon bubbles (header + drawer)
        const currentBubbles = document.querySelectorAll('.cart-bubble');
        const newBubbles = doc.querySelectorAll('.cart-bubble');
        currentBubbles.forEach((bubble, index) => {
          if (newBubbles[index]) {
            bubble.outerHTML = newBubbles[index].outerHTML;
          }
        });

        // Update customer target progress bar
        const currentTargetProgress = document.querySelector('.vc-customer-target-progress');
        const newTargetProgress = doc.querySelector('.vc-customer-target-progress');
        if (currentTargetProgress && newTargetProgress) {
          currentTargetProgress.outerHTML = newTargetProgress.outerHTML;
        }

        // Reinitialize recommendations after cart update
        setTimeout(() => {
          isUpdatingRecommendation = false;
          loadRecommendations();
        }, 300);
      }
    } catch (error) {
      console.error('Add to cart error:', error);
      isUpdatingRecommendation = false;
    }
  }

  // Keep old function name for compatibility
  async function handleQuantityChange(input, variantId) {
    updatePrice(input);
  }

  async function loadRecommendations() {
    const container = document.getElementById('vc-cart-recommendations-container');
    if (!container) return;

    // Get current cart items from DOM (exclude recommendations)
    const cartItems = document.querySelectorAll('.vc-cart-item[data-product-id]:not(.vc-cart-item--recommendation)');
    if (!cartItems || cartItems.length === 0) return;

    // Extract product IDs, variant IDs with quantities and check for Akku products
    const cartProductMap = new Map(); // productId -> { id, quantity, title }
    const cartProductIds = [];
    const cartVariantIds = []; // Track variant IDs in cart
    let hasAkkuInCart = false;

    cartItems.forEach(item => {
      const productId = item.getAttribute('data-product-id');
      if (!productId) return;

      const id = parseInt(productId);

      // Get variant ID from data-key (format: "variantId:..." or just key)
      const dataKey = item.getAttribute('data-key');
      if (dataKey) {
        // Extract variant ID from key - format varies, but first part is usually variant ID
        const variantId = parseInt(dataKey.split(':')[0]);
        if (variantId && !cartVariantIds.includes(variantId)) {
          cartVariantIds.push(variantId);
        }
      }

      // Get quantity from quantity selector
      const quantityInput = item.querySelector('.vc-cart-quantity input[type="number"]');
      const quantity = quantityInput ? parseInt(quantityInput.value) || 0 : 0;

      // Get product title
      const titleElement = item.querySelector('.vc-cart-item__title');
      const title = titleElement ? titleElement.textContent.trim() : '';

      // Check if product title contains "Akku"
      if (title.toLowerCase().includes('akku')) {
        hasAkkuInCart = true;
      }

      // Store product info
      if (!cartProductMap.has(id)) {
        cartProductMap.set(id, { id, quantity, title });
        cartProductIds.push(id);
      }
    });

    if (cartProductIds.length === 0) return;

    // Sort products by quantity (highest first) and take top 3
    const topProducts = Array.from(cartProductMap.values())
      .sort((a, b) => b.quantity - a.quantity)
      .slice(0, 3);

    // Randomize the order of top products for variety
    const shuffledTopProducts = topProducts.sort(() => Math.random() - 0.5);

    // Try to fetch recommendations from each top product until we find valid ones
    let filtered = [];
    let sourceProductIsNikotinfrei = false;

    for (const product of shuffledTopProducts) {
      const recommendations = await fetchRecommendations(product.id, 10);
      if (!recommendations || recommendations.length === 0) continue;

      // Check if source product is nikotinfrei
      sourceProductIsNikotinfrei = product.title.toLowerCase().includes('nikotinfrei');

      // Filter out products/variants already in cart
      filtered = recommendations.filter(rec => {
        // If product has no variants (or only default), check if product is in cart
        if (!rec.variants || rec.variants.length <= 1) {
          return !cartProductIds.includes(rec.id);
        }

        // If product has variants, check if at least one variant is NOT in cart
        const hasAvailableVariant = rec.variants.some(variant => {
          return variant.available && !cartVariantIds.includes(variant.id);
        });

        return hasAvailableVariant;
      });

      // If cart contains Akku product, filter out all Akku recommendations
      if (hasAkkuInCart) {
        filtered = filtered.filter(rec => !rec.title.toLowerCase().includes('akku'));
      }

      // If we found valid recommendations, stop searching
      if (filtered.length > 0) break;
    }

    if (filtered.length === 0) return;

    // Filter out products with no available variants
    filtered = filtered.filter(product => {
      return product.variants && product.variants.some(v => v.available);
    });

    if (filtered.length === 0) return;

    // Prioritize recommendations based on nikotinfrei preference
    let candidateRecs;
    if (sourceProductIsNikotinfrei) {
      // Source is nikotinfrei → prefer nikotinfrei recommendations
      const nikotinfreiRecs = filtered.filter(rec => rec.title.toLowerCase().includes('nikotinfrei'));
      candidateRecs = nikotinfreiRecs.length > 0 ? nikotinfreiRecs : filtered;
    } else {
      // Source is NOT nikotinfrei → prefer non-nikotinfrei recommendations
      const nonNikotinfreiRecs = filtered.filter(rec => !rec.title.toLowerCase().includes('nikotinfrei'));
      candidateRecs = nonNikotinfreiRecs.length > 0 ? nonNikotinfreiRecs : filtered;
    }

    // Exclude last recommended product if there are other options
    if (lastRecommendedProductId && candidateRecs.length > 1) {
      const withoutLast = candidateRecs.filter(rec => rec.id !== lastRecommendedProductId);
      if (withoutLast.length > 0) {
        candidateRecs = withoutLast;
      }
    }

    // Pick randomly from top 3 for variety
    const topThree = candidateRecs.slice(0, 3);
    const firstRec = topThree[Math.floor(Math.random() * topThree.length)];

    // Remember this product for next time
    lastRecommendedProductId = firstRec.id;

    container.innerHTML = `
      <div class="vc-cart-recommendations">
        ${createRecommendationHTML(firstRec, cartVariantIds)}
      </div>
    `;
  }

  function init() {
    // Load recommendations when cart drawer opens
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          const cartDrawer = mutation.target;
          if (cartDrawer.classList.contains('cart-drawer__dialog') && cartDrawer.hasAttribute('open')) {
            setTimeout(loadRecommendations, 100);
          }
        }
      }
    });

    // Observe cart drawer dialog
    const cartDrawer = document.querySelector('.cart-drawer__dialog');
    if (cartDrawer) {
      observer.observe(cartDrawer, { attributes: true });
    }

    // Also load on page load if cart drawer is already open or on /cart page
    const isCartPage = window.location.pathname.includes('/cart');
    if ((cartDrawer && cartDrawer.hasAttribute('open')) || isCartPage) {
      loadRecommendations();
    }

    // Reload recommendations when cart updates
    document.addEventListener('cart:update', () => {
      // Skip if recommendation is being updated
      if (isUpdatingRecommendation) return;

      // Wait for cart to update, then reload recommendations if drawer is open or on /cart page
      setTimeout(() => {
        const cartDrawer = document.querySelector('.cart-drawer__dialog');
        const isCartPage = window.location.pathname.includes('/cart');
        if ((cartDrawer && cartDrawer.hasAttribute('open')) || isCartPage) {
          loadRecommendations();
        }
      }, 300);
    });

    // Also listen to cart:refresh for recommendation add-to-cart
    document.documentElement.addEventListener('cart:refresh', () => {
      setTimeout(() => {
        const cartDrawer = document.querySelector('.cart-drawer__dialog');
        const isCartPage = window.location.pathname.includes('/cart');
        if ((cartDrawer && cartDrawer.hasAttribute('open')) || isCartPage) {
          loadRecommendations();
        }
      }, 300);
    });
  }

  function reloadRecommendations() {
    loadRecommendations();
  }

  return {
    init,
    handleQuantityChange,
    updateQuantity,
    updatePrice,
    addToCartFromButton,
    reloadRecommendations
  };
})();

// Expose to global scope for inline handlers
window.CartRecommendations = CartRecommendations;


/* ========================================
   5. INITIALIZATION
   ======================================== */

function init() {
  CartTooltip.init();
  ModalCustomization.initObserver();
  CollectionRowGradients.init();
  CartRecommendations.init();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
